// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".input-label[data-v-5b9a285b] {\n  display: inline-block;\n  width: 60px;\n  color: #666666;\n}\n.route-form .lable-blue[data-v-5b9a285b]  .el-form-item__label {\n  color: blue !important;\n}\n", ""]);
// Exports
module.exports = exports;
